




import { bemBuilder } from "@/v2/util/bem-builder";
import { defineComponent } from "@vue/composition-api";

const css = bemBuilder("atom-pulsating-circle");

export default defineComponent({
  name: "AtomPulsatingCircle",
  setup() {
    return {
      css,
    };
  },
});
